export interface PasswordStrength {
  score: number;
  feedback: string[];
}

export const calculatePasswordStrength = (password: string): PasswordStrength => {
  const strength: PasswordStrength = {
    score: 0,
    feedback: [],
  };

  if (!password) {
    strength.feedback.push('password_is_required');
    return strength;
  }

  // Comprimento mínimo
  if (password.length < 8) {
    strength.feedback.push('password_should_be_at_least_8_characters_long');
  } else {
    strength.score += 1;
  }

  // Letras maiúsculas
  if (!/[A-Z]/.test(password)) {
    strength.feedback.push('add_uppercase_letters');
  } else {
    strength.score += 1;
  }

  // Letras minúsculas
  if (!/[a-z]/.test(password)) {
    strength.feedback.push('add_lowercase_letters');
  } else {
    strength.score += 1;
  }

  // Números
  if (!/\d/.test(password)) {
    strength.feedback.push('add_numbers');
  } else {
    strength.score += 1;
  }

  // Caracteres especiais
  if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
    strength.feedback.push('add_special_characters');
  } else {
    strength.score += 1;
  }

  return strength;
}; 